import { IUser } from "../../auth/models/user";
import { getAppInsights } from "./applicationInsights";

const commonHeaders = {
  "Content-Type": "application/json",
  DataLoggingKey: "ABAE5CDA-C51A-47BF-833C-812B57465946",
};

export async function request<T>(
  url: string,
  options: RequestInit,
  mapResponse?: (data: any) => Readonly<T>
): Promise<Readonly<T>> {
  const response = await fetch(url, options);
  let data: any = await response.text();

  if (!response.ok) {
    const ai = getAppInsights();
    ai.trackEvent({
      name: "Catched failed request",
      properties: {
        httpCode: response.status,
        url: url,
        options: options,
        errorMessage: data ? data : "",
      },
    });
    throw new Error(`${response.status}`);
  }

  data = data ? JSON.parse(data) : {};

  if (data.status && data.status.toLowerCase() === "ok") {
    if (mapResponse) {
      return mapResponse(data);
    }
  } else if (data.status && data.status.toLowerCase() === "error") {
    throw new Error(data.payload.errorCode);
  }

  return data as T;
}

export async function get<T>(
  pathFn: string,
  mapResponse?: (data: any) => Readonly<T>,
): Promise<T> {
  const opts: RequestInit = {
    method: "GET",
    headers: {
      ...getCommonHeaders(),
    },
  };

  return request(pathFn, opts, mapResponse);
}

export async function post<T, K>(
  pathFn: string,
  body: K,
  mapResponse?: (data: any) => Readonly<T>
): Promise<Readonly<T>> {
  const opts: RequestInit = {
    method: "POST",
    headers: {
      ...getCommonHeaders(),
    },

    body: JSON.stringify(body),
  };

  return request(pathFn, opts, mapResponse);
}

export async function put<T, K>(
  pathFn: string,
  body: K,
  mapResponse?: (data: any) => Readonly<T>
): Promise<Readonly<T>> {
  const opts: RequestInit = {
    method: "PUT",
    headers: {
      ...getCommonHeaders(),
    },

    body: JSON.stringify(body),
  };

  return request(pathFn, opts, mapResponse);
}

export async function del<T>(
  pathFn: string,
  mapResponse?: (data: any) => Readonly<T>
): Promise<Readonly<T>> {
  const opts: RequestInit = {
    method: "DELETE",
    headers: {
      ...getCommonHeaders(),
    },
  };
  return request(pathFn, opts, mapResponse);
}

const getCommonHeaders = () => {
  const userJSON = localStorage.getItem("currentUser");
  if (!userJSON) return commonHeaders;

  const user: IUser = JSON.parse(userJSON);
  if (user) {
    return {
      ...commonHeaders,
      Authorization: `Bearer ${user.token}`,
    };
  }

  return commonHeaders;
};
